import React from "react";
import { useState } from 'react';
//React Router
import { useNavigate } from 'react-router-dom'

// tools and component for date picker
import dayjs from 'dayjs';

//selectors for redux :
import { useSelector } from "react-redux";
import { getIdSpotLoc, getLivraison, getRidingPeriod, getPanier, getUserData, getCommentaire, getAccess, getContrat } from "../../../../../../store/selectors.js";
import { useDispatch } from "react-redux";
import { contratSlice } from "../../../../../../store/contratSlice.js";
import { contratStepSlice } from "../../../../../../store/contratStepSlice.js";
import { accessoiresSlice } from "../../../../../../store/accessoiresSlice.js";
import { checkCGVSlice } from "../../../../../../store/checkCGVSlice.js";
import { commentaireSlice } from "../../../../../../store/commentaireSlice.js";
import { dureeSlice } from "../../../../../../store/dureeSlice.js";
import { livraisonSlice } from "../../../../../../store/livraisonSlice.js";
import { panierSlice } from "../../../../../../store/panierSlice.js";
import { periodHeuresSlice } from "../../../../../../store/periodSlice.js";
import { periodDatesSlice } from "../../../../../../store/periodSlice.js";
import { userDataSlice } from "../../../../../../store/userDataSlice.js";

//MUI Components
import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Alert from '@mui/material/Alert';
import Modal from '@mui/material/Modal';
import CircularProgress from '@mui/material/CircularProgress';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import MoneyIcon from '@mui/icons-material/Money';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import PaymentsIcon from '@mui/icons-material/Payments';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import CheckIcon from '@mui/icons-material/Check';


//import Fetch API functions
import { getArticles, getOneSpot, getAllTarifs, getContratByRef, getAccessoires } from '../../../../../../database/fetchApi.js'

//created components
import BlocRecap from '../../../../../../steps/step5/components/blocrecap/BlocRecap.jsx'

//Utils functions
import { prepareDureeTexte } from '../../../../../../utils/calcul_duree.js'
import calculDuree from '../../../../../../utils/calcul_duree.js' //we import this method because there is a bug to store the duree in Redux (infinite loop)
import { calcPrixDegressif } from "../../../../../../utils/calcul_prix.js" //parms : tarifs object, duree object
import { prepAdresse } from '../../../../../../utils/prepa_adresse_paiement.js'; //url preparation for axepta
import prepaMailContrat from "../../../../../../utils/prepa-mail-contrat.js" //params : fullContrat 

// API fetch
import axios from "axios";
import { baseURL, cloudRunBaseURL } from '../../../../../../config/api-config.js';
import { IndeterminateCheckBoxOutlined } from "@mui/icons-material";

function StepSeven() { // component to manage the first step of shopping : choosing place and time

    const [articles, setArticles] = useState([]);
    const [accessoires, setAccessoires] = useState([]);
    const [tarifs, setTarifs] = useState([]);
    const [spotInfos, setSpotInfos] = useState(null); //null is set by default so we can 
    const [fail, setFail] = useState(false); //state : api request failed
    const [infos, setInfos] = React.useState("");
    const [open, setOpen] = React.useState(false);
    const [ref, setRef] = React.useState("");
    const [contratID, setContratID] = React.useState();
    const [paymentUrl, setPaymentUrl] = useState(""); //state : api request failed
    const [lock, setLock] = useState(true); //state : modify total price
    const [showLoading, setShowLoading] = useState(false);

    let successRequest = 0;

    const idSpot = useSelector(getIdSpotLoc); //global state : id of the selected spo
    const accessList = useSelector(getAccess); //global state : id of the selected spo
    const infosLivraison = useSelector(getLivraison); //global state : id of the selected spo
    const period = useSelector(getRidingPeriod); //global state : id of the selected spo
    const userInfos = useSelector(getUserData); //global state : id of the selected spo
    let panier = useSelector(getPanier); //get global state : panier
    let commentaire = useSelector(getCommentaire); //get global state : panier
    let fullContrat = useSelector(getContrat); //get global state : panier
    const dureeObject = calculDuree(period); //get object with quantity for every durations (demis,jour, semaine...)

    let periode = useSelector(getRidingPeriod);

    const [customPrice, setCustomPrice] = useState(0); //state : modify total price
    const [cumulPrice, setCumulPrice] = useState(0); //state : modify total price
    const [priceError, setPriceError] = useState(false); //state : modify total price
    const [paiementModes, setPaiementModes] = useState([{ type: 2, montant: 0 }]); //state : modify total price
    const [cumulError, setCumulError] = useState(false); //state : modify total price
    const [cautionType, setCautionType] = useState(0); //state : modify total price
    const [cautionDetails, setCautionDetails] = useState(""); //state : modify total price
    const [comment2, setComment2] = useState(""); //state : modify total price
    const [mailChecked, setMailChecked] = useState(true); //state : modify total price
    const [insertError, setInsertError] = useState(""); //state : modify total price
    const [currentContrat, setCurrentContrat] = useState(); //
    //let paiementModes = [{ type: 2, montant: 0 }];
    let paiementModesList = [
        { type: 2, intitule: "Espèces" },
        { type: 3, intitule: "CB" },
        { type: 4, intitule: "Chèque" },
        { type: 5, intitule: "ANCV" },
        { type: 6, intitule: "Virement" }
    ];

    let garantiesList = [
        "- Choisissez -", "Pièce d'identité", "Empreinte CB", "Chèque", "Autre"
    ];


    const dispatch = useDispatch();
    const navigate = useNavigate();


    React.useEffect(() => { //change opening hours when spot change (idspot as dependency)

        async function initArticles() { //we add this inner function to manage asynchrone
            let allArticles = await getArticles();
            setArticles([].concat(allArticles))
        } //end of async function
        initArticles(); //call the inner asnchrone function

        async function initAccessoires() { //we add this inner function to manage asynchrone
            let allAccessoires = await getAccessoires();
            setAccessoires([].concat(allAccessoires))
        } //end of async function
        initAccessoires(); //call the inner asnchrone function

        async function initSpot() { //we add this inner function to manage asynchrone
            let infosSpot = await getOneSpot(idSpot);
            setSpotInfos(infosSpot)
        } //end of async function
        initSpot(); //call the inner asnchrone function 

        async function initTarifs() { //we add this inner function to manage asynchrone
            let allTarifs = await getAllTarifs();
            setTarifs(allTarifs)
        } //end of async function
        initTarifs(); //call the inner asnchrone function 

        async function initContrat() { //we add this inner function to manage asynchrone
            console.log(fullContrat)
            let contrat = await getContratByRef(fullContrat.ref_contrat);
            setCurrentContrat(contrat)
            console.log(contrat)
        } //end of async function
        initContrat(); //call the inner asnchrone function 

    }, [])

    React.useEffect(() => { //reset customprice on lock
        if (lock === true) {
            setCustomPrice(getCumul().total);
        }
    }, [lock])

    React.useEffect(() => { //reset customprice on lock

        if (panier.length > 0 && articles.length > 0) {
            setCustomPrice(getCumul().total);
            setPaiementModes([{ type: 2, montant: getCumul().total }])

        }

    }, [panier, articles])



    function findArticle(id) {
        try {
            return articles.find((item) => item.id_article === id);

        }
        catch {
            //console.log('error find')
        }
    }

    function getCumul() {
        let total = 0;
        let lignes = [];

        if (panier.length > 0) {
            panier.map((ligne) => {
                let articleCourant = findArticle(ligne.id_article);
                if (typeof articleCourant !== 'undefined') {
                    let pu = ligne.qte * calcPrixDegressif(articleCourant.Tarif, calculDuree(periode));
                    //let infosArticle = ligne.qte + " x " + articleCourant.type + " : " + pu + ",00€";
                    let infosArticle = { qte: ligne.qte, type: articleCourant.type, pu };
                    total += pu;
                    lignes.push(infosArticle);
                }
            });
        }

        return { total: currentContrat ? currentContrat.total : 0, lignes };
    }



    function getUserInfos(infos) { // infos is an boject sent from StepTwo.jsx, With 3 attibutes : spot, dates, duree
        return (
            <div className="bloc-recap-infos-user">
                <p>{infos.prenom} {infos.nom}</p>
                <div className="bloc-recap-infos-user-bloc">
                    <p>{infos.tel}</p>
                    <p>{infos.email}</p>
                </div>
                <div className="bloc-recap-infos-user-bloc">
                    <p>{infos.adresse}, {infos.adresse_comp}</p>
                    <p>{infos.cp}, {infos.ville}, {infos.pays}</p>
                </div>



            </div>
        )
    }

    function getPeriodInfos() { // infos is an boject sent from StepTwo.jsx, With 3 attibutes : spot, dates, duree

        let dateDeb = "";
        let dateFin = "";
        let duree = "";

        //prepare dates infos
        dateDeb += "du " + dayjs(period[0][0]).format("DD/MM/YYYY");
        dateDeb += " à " + period[1][0] + "h00";
        dateFin += " au " + dayjs(period[0][1]).format("DD/MM/YYYY");
        dateFin += " à " + period[1][1] + "h00";

        //Prepare duree infos
        duree = prepareDureeTexte(dureeObject);

        return (
            <div className="bloc-recap-infos-duree">
                <p className="bloc-recap-infos-duree-date">{dateDeb}</p>
                <p className="bloc-recap-infos-duree-date">{dateFin}</p>
                <p className="bloc-recap-infos-duree-cumul">soit : {duree}</p>
            </div>
        )
    }

    function getSpotInfos() { // infos is an boject sent from StepTwo.jsx, With 3 attibutes : spot, dates, duree

        let spot1 = "";
        let spot2 = "";

        // prepare spot infos
        if (idSpot >= 99) {
            spot1 = "Livraison : " + infosLivraison.secteur; // if spot is 'Livraison' (id=99), we collect secteur and adresse from object stored in global state
            spot2 = infosLivraison.adresse; // if spot is 'Livraison' (id=99), we collect secteur and adresse from object stored in global state
        }
        else { // spot is not livraion
            if (spotInfos) { // if promise not fullfilled yet, we block the process to evoid error
                spot1 = spotInfos.nom_spot;
                spot2 = spotInfos.adresse_spot + " " + spotInfos.ville_spot;
            }
        }

        return (
            <div className="bloc-recap-infos-spot">
                <p>{spot1}</p>
                <p>{spot2}</p>
            </div>
        )
    }



    function getCartInfos() { // infos is an boject sent from StepTwo.jsx, With 3 attibutes : spot, dates, duree
        let { total, lignes } = getCumul();

        return (
            <div className="bloc-recap-infos-cart">
                <div className="bloc-recap-infos-cart-top">
                    <Table aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell>Article</TableCell>
                                <TableCell align="center">Quantité</TableCell>
                                <TableCell align="center">Tarif</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {lignes.map((row) => (
                                <TableRow
                                    key={row.type}
                                >
                                    <TableCell component="th" scope="row">
                                        {row.type}
                                    </TableCell>
                                    <TableCell align="center">{row.qte}</TableCell>
                                    <TableCell align="center">{row.pu},00€</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>

                </div>
                <div className="bloc-recap-infos-cart-total">
                    <h3>Montant total du panier :</h3>
                    <p>{total},00 €</p>
                </div>
                <div className="bloc-recap-infos-cart-bottom">
                    {
                        commentaire.length > 1 ? //display only if commentaire is set
                            <div>
                                <h3>Commentaire :</h3>
                                <p>{commentaire}</p>
                            </div>
                            : null
                    }
                    {
                        currentContrat && currentContrat.commentaire2.length > 1 ? //display only if commentaire is set
                            <div>
                                <h3>Commentaire 2 :</h3>
                                <p>{currentContrat.commentaire2}</p>
                            </div>
                            : null
                    }

                </div>



            </div>
        )
    }


    function getAccessInfos() { // infos is an boject sent from StepTwo.jsx, With 3 attibutes : spot, dates, duree
        // let {total, lignes} = getCumul();

        return (
            <div className="bloc-recap-infos-cart">
                <div className="bloc-recap-infos-cart-top">
                    <Table aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell>Acessoires</TableCell>
                                <TableCell align="center">Quantité</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {accessList.map((row) => (
                                <TableRow
                                    key={row.id_article}
                                >
                                    <TableCell component="th" scope="row">
                                        {accessoires.length > 0 ? accessoires.find((info) => info.id_article === row.id_article).type : " "}
                                    </TableCell>
                                    <TableCell align="center">{row.qte}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>

                </div>

            </div>
        )
    }


    function newContrat() {

        dispatch(contratSlice.actions.setContrat({})); //reset contrat
        dispatch(accessoiresSlice.actions.resetPanier()); //reset access
        dispatch(checkCGVSlice.actions.resetCGV()); //reset cvg
        dispatch(commentaireSlice.actions.setCommentaire("")); //reset commentaire
        dispatch(dureeSlice.actions.setDuree({})); //reset duree
        dispatch(livraisonSlice.actions.setLivraison({})); //reset livraiosn
        dispatch(panierSlice.actions.resetPanier()); //reset access

        //dispatch(periodHeuresSlice.actions.setHeure([0, 0])); //reset access
        //dispatch(periodDatesSlice.actions.setDate([dayjs().format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')])); //reset access

        dispatch(periodHeuresSlice.actions.setHeure({ heure: 0, index: 1 })); //reset access
        dispatch(periodHeuresSlice.actions.setHeure({ heure: 0, index: 2 })); //reset access

        dispatch(periodDatesSlice.actions.setDate({ jour: dayjs().format('YYYY-MM-DD'), index: 1 })); //reset access
        dispatch(periodDatesSlice.actions.setDate({ jour: dayjs().format('YYYY-MM-DD'), index: 2 })); //reset access


        dispatch(userDataSlice.actions.setUserData({
            found: false,
            id_client: 0,
            tel: "",
            email: "",
            prenom: "",
            nom: "",
            adresse: "",
            adresse_comp: "",
            cp: "",
            ville: "",
            pays: ""
        })); //reset userData

        dispatch(contratStepSlice.actions.goToContratStep(1)); //go to step 1

    }



    return (
        <div className="step5">
            <div className="step7-header">
                <h1>Le nouveau contrat a bien été enregistré <CheckIcon /></h1>
            </div>

            <div className="step5-top">
                <h1>Recapitulatif du Contrat</h1>
            </div>
            <div className="step5-blocs">
                <div className="step5-blocs-left">
                    <BlocRecap step={1} edit={false} titre={"Votre point de location :"} infos={getSpotInfos()} />
                    <BlocRecap step={1} edit={false} titre={"Durée de location :"} infos={getPeriodInfos()} />
                    <BlocRecap step={2} edit={false} titre={"Vos articles :"} infos={getCartInfos()} />

                </div>
                <div className="step5-blocs-right">
                    <BlocRecap step={3} edit={false} titre={"Vos accessoires :"} infos={getAccessInfos()} />
                    <BlocRecap step={4} edit={false} titre={"Vos informations :"} infos={getUserInfos(userInfos)} />
                </div>

            </div>

            <div className="step7-bottom">

            </div>




        </div>

    )
}




export default StepSeven






